export default {
    user: {
        create: {
            title: "Nový uživatel",
            model: {
                email: {
                    label: "E-mail",
                    placeholder: "Vyplňte e-mail"
                },
                name: {
                    label: "Jméno",
                    placeholder: "Vyplňte jméno"
                },
                country: {
                    label: "Země",
                    placeholder: "Vyplňte zemi"
                },
                approval_manager_email: {
                    label: "E-mail manažera",
                    placeholder: "Vyplňte e-mail manažera",
                    errors: {
                        different: "E-mailová adresa správce schvalování se musí lišit od e-mailové adresy uživatele."
                    }
                }
            },
            cta: {
                submit: {
                    text: "Předložit",
                    processing: "Odesílání"
                },
                cancel: {
                    text: "Zrušit"
                }
            }
        },
        country: {
            title: "Země uživatele",
            header: "{email} nemá vybranou zemi. Vyberte prosím jejich zemi.",
            model: {
                country: {
                    label: "Země",
                    placeholder: "Vyplňte zemi"
                }
            },
            cta: {
                submit: {
                    text: "Předložit",
                    processing: "Odesílání"
                },
                cancel: {
                    text: "Zrušit"
                }
            }
        }
    }
}